import { useDispatch } from 'react-redux';

export default function useStoreAddOnSelection() {
    const dispatch = useDispatch();

    const executor = (car_addOn_selection) => {
        return dispatch({
            type: 'SET_CAR_ADD_ON_SELECTION',
            payload: car_addOn_selection,
        });
    };

    return executor;
};